import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "switch"
}
const _hoisted_2 = ["name", "value"]
const _hoisted_3 = { class: "strip" }
const _hoisted_4 = { class: "on" }
const _hoisted_5 = { class: "off" }
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, [
          _createElementVNode("input", {
            type: "hidden",
            name: _ctx.name,
            value: _ctx.inputValue ? _ctx.onValue : _ctx.offValue
          }, null, 8 /* PROPS */, _hoisted_2),
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sliderToggle && _ctx.sliderToggle(...args)), ["stop"])),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputValue) = $event))
          }, null, 512 /* NEED_PATCH */), [
            [_vModelCheckbox, _ctx.inputValue]
          ]),
          _createElementVNode("span", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.onText), 1 /* TEXT */),
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "pin" }, null, -1 /* CACHED */)),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.offText), 1 /* TEXT */)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("i", {
            class: "text-orange d-inline-block fi-arrows-cw spin",
            style: {"margin-right":"24px"}
          }, null, -1 /* CACHED */)
        ]))]))
      : _createCommentVNode("v-if", true)
  ]))
}